import { QUERY_KEYS } from "@/common/query-keys";
import { fetchStatusLabels } from "@/lib/snipeit/lookups";
import { useQuery } from "@tanstack/react-query";
import { VERWERTER_STATUS } from "../constants";

/**
 * Fetches all status labels and selects the "Verwerter" label.
 */
export function useVerwerterLabel() {
  return useQuery({
    queryKey: [QUERY_KEYS.statusLabels],
    queryFn: fetchStatusLabels,
    staleTime: 5 * 60_000,
    select: (labels) => labels.find((label) => label.name === VERWERTER_STATUS),
  });
}
